import EditableDetailPanel from 'Components/Generic/DetailPanel/EditableDetailPanel';
import PropTypes from 'prop-types';
import ResourcesTable from './ResourcesTable';

const ResourceListPanel = ({
  editable = false,
  disabled = false,
  ...props
}) => {
  return (
    <EditableDetailPanel
      title='Resources'
      editable={editable}
      disabled={disabled}
      collapsible
      renderChild={(inEditState) => {
        return <ResourcesTable editable={inEditState} {...props} />;
      }}
    />
  );
};

ResourceListPanel.propTypes = {
  editable: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ResourceListPanel;
